import { connect } from 'react-redux';

import { getUserInitials } from '../../utils/user';
import UserIcon from '../UserIcon';

const mapStateToProps = (state) => {
  const { profile } = state.auth.userInfo;

  return {
    imgData: profile.avatar,
    initials: getUserInitials(profile),
  };
};

export default connect(
  mapStateToProps,
)(UserIcon);
